import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination, EffectFade, Navigation } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Autoplay, EffectFade]);

// import { gsap } from "gsap";
const digitalSolutionsFader = function (barba) {
	const speed = 2000
	const swiper = new Swiper('.imac-swiper .screen-content', {
		loop: true, 
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 3500,
		},
	})
}

export default digitalSolutionsFader